import React from 'react';

const PlaneGeometry = (props) => (
  <planeBufferGeometry {...props} args={[100.1, 100.1]} />
);

export default PlaneGeometry;